import React from "react";
import Styles from './styles.module.scss';

import activeInner from '../../../theme/assets/redesign/rings/active_inner.svg';
import activeOutline from '../../../theme/assets/redesign/rings/active_outline.svg';
import activeTrack from '../../../theme/assets/redesign/rings/active_track.svg';
import activeProgress from '../../../theme/assets/redesign/rings/active_progress.svg';
import activeHighlight from '../../../theme/assets/redesign/rings/active_highlight.svg';
import completedInner from '../../../theme/assets/redesign/rings/completed_inner.svg';
import completedOutline from '../../../theme/assets/redesign/rings/completed_outline.svg';
import completedTrack from '../../../theme/assets/redesign/rings/completed_track.svg';
import completedProgress from '../../../theme/assets/redesign/rings/completed_progress.svg';
import completedHighlight from '../../../theme/assets/redesign/rings/completed_highlight.svg';
import upcomingInner from '../../../theme/assets/redesign/rings/upcoming_inner.svg';
import upcomingOutline from '../../../theme/assets/redesign/rings/upcoming_outline.svg';
import upcomingTrack from '../../../theme/assets/redesign/rings/upcoming_track.svg';
import upcomingProgress from '../../../theme/assets/redesign/rings/upcoming_progress.svg';
import upcomingHighlight from '../../../theme/assets/redesign/rings/upcoming_highlight.svg';

// Геометрия слоёв из Figma (Brush Ring): [x, y, w, h] в px относительно квадрата size×size
// (размеры — как у экспортированных SVG, у highlight они больше из-за размытия).
// Кольцо масштабируется под любой размер карточки — всё пересчитывается в проценты.
const RINGS = {
    active: {
        size: 310,
        inner: [activeInner, 30.25, 30.25, 250, 250],
        outline: [activeOutline, -3.25, -4, 317, 319],
        track: [activeTrack, -6.25, -16.5, 326, 327],
        progress: [activeProgress, 0.25, -6, 317, 315],
        highlight: [activeHighlight, 105.9, -40, 141, 104],
    },
    completed: {
        size: 270,
        inner: [completedInner, 27.75, 27, 215, 216],
        outline: [completedOutline, -2.1, -2.25, 274, 277],
        track: [completedTrack, 0, 3, 278, 269],
        progress: [completedProgress, -4.75, 4, 275, 267],
        highlight: [completedHighlight, 103.5, -21.5, 101, 68],
    },
    upcoming: {
        size: 270,
        inner: [upcomingInner, 25.25, 27.1, 217, 216],
        outline: [upcomingOutline, -2.4, -1.4, 275, 273],
        track: [upcomingTrack, -8.25, 4.4, 287, 263],
        progress: [upcomingProgress, 1.6, 1.6, 265, 267],
        highlight: [upcomingHighlight, 103.4, -23.1, 100, 72],
    },
};

// маска прогресса шире кольца на 10% с каждой стороны (как фрейм Progress в Figma)
const MASK_PAD = 0.1;

const pct = v => `${v * 100}%`;

const layerStyle = ([, x, y, w, h], size, pad = 0) => {
    const box = size * (1 + pad * 2);
    return {
        left: pct((x + size * pad) / box),
        top: pct((y + size * pad) / box),
        width: pct(w / box),
        height: pct(h / box),
    };
};

const BrushRing = ({tone = 'active', percent = 0}) => {
    const ring = RINGS[tone] || RINGS.active;
    const p = Math.max(0, Math.min(100, Number(percent) || 0));
    const mask = `conic-gradient(from 0deg at 50% 50%, #000 0 ${p}%, transparent ${p}% 100%)`;

    return (
        <div className={`${Styles.ring} ${Styles[`ring_${tone}`]}`} aria-hidden="true">
            {['track', 'outline', 'inner'].map(key => (
                <img key={key} className={Styles.ringLayer} src={ring[key][0]} style={layerStyle(ring[key], ring.size)} alt=""/>
            ))}
            {p > 0 ? (
                <div className={Styles.ringProgress} style={{WebkitMaskImage: mask, maskImage: mask}}>
                    <img className={Styles.ringLayer} src={ring.progress[0]} style={layerStyle(ring.progress, ring.size, MASK_PAD)} alt=""/>
                </div>
            ) : null}
            <img className={Styles.ringLayer} src={ring.highlight[0]} style={layerStyle(ring.highlight, ring.size)} alt=""/>
        </div>
    );
};

export default BrushRing;
